import React from "react";

const GradientBar = () => <div className="bg-gradient h-1" />;

export default GradientBar;
